import type { ImproveNotesTaskId } from '../../contracts/post-note-quality';

import { getScribeHttpClients } from '@heidi/api/client';

interface ScribeHttpV2 {
  patch<T>(url: string): Promise<{ data: T }>;
  post<T>(url: string): Promise<{ data: T }>;
}

const http = (): ScribeHttpV2 =>
  getScribeHttpClients().scribeHttpV2 as unknown as ScribeHttpV2;

export function markPostNoteQualityTaskCompleted(taskId: ImproveNotesTaskId) {
  return http().patch<void>(`/user/post-note-quality/tasks/${taskId}`);
}

export function dismissPostNoteQualityPanel() {
  return http().post<void>('/user/post-note-quality:dismiss');
}

/** Marks the panel as seen so later opens report a repeat view. Idempotent. */
export function markPostNoteQualityPanelSeen() {
  return http().post<void>('/user/post-note-quality:mark-seen');
}
